



















































import { Component, Vue } from 'vue-property-decorator';
import moment from 'moment';
import { EventPaginationOptions } from '@/modules/events/interfaces/event-pagination.options.interface';
import { EventStatus } from '@/modules/events/interfaces/event.interface';

@Component({ name: 'SearchFilter' })
export default class SearchFilter extends Vue {
  private params = {
    search: '',
    dates: [],
    status: [],
    limit: 100,
    page: 1,
  };

  emitEventPaginationOptions() {
    const search = this.params.search;
    const limit = this.params.limit;
    const page = this.params.page;
    const status = this.params.status.map((s: string) => s as EventStatus);

    const params: EventPaginationOptions = {
      search,
      limit,
      page,
      status,
    };

    const [start, end] = this.params.dates;
    const now = moment();
    if (start) {
      params.startDate = start + now.startOf('day').toISOString().substr(10);
    }
    if (end) {
      params.endDate = end + now.startOf('day').toISOString().substr(10);
    }

    this.$emit('new-filters', params);
  }
}
